<template>
    <section class="app-main">

        
        <div class="top-bar">
            <div class="right-total">
                <div>
                    <el-tag type="primary">交易订单总量：{{Total}}</el-tag>
                </div>
                <div style="margin-top:10px;">
                     <el-tag  type="danger">退款订单总量：{{refundTotal}}</el-tag>
                </div>
            </div>
            <div class="m-bottom-3">
                <!-- <el-tag  type="success">所有总计：C${{totalMoney.current_total_amount}}</el-tag> -->
                <!-- <el-tag  type="success">当页总计：C${{totalMoney.current_page_amount}}</el-tag> -->
                <el-tag  type="success">支付总计：C${{totalMoney.CAD.total_pay_amount}} + US${{totalMoney.USD.total_pay_amount}}</el-tag>
                <el-tag  type="warning">退款总计：C${{totalMoney.CAD.total_refund_amount}} + US${{totalMoney.USD.total_refund_amount}}</el-tag>
                <el-tag v-show="checkItem.includes('1')" type="primary"  >支付宝：C${{totalMoney.CAD.alipay_amount}} + US${{totalMoney.USD.alipay_amount}}</el-tag>
                <el-tag v-show="checkItem.includes('2')" type="success"  >微信：C${{totalMoney.CAD.wechat_amount}} + US${{totalMoney.USD.wechat_amount}}</el-tag>
                <el-tag v-show="checkItem.includes('3')" type="danger"  >VISA/Master：C${{totalMoney.CAD.visa_mastercard_amount}} + US${{totalMoney.USD.visa_mastercard_amount}}</el-tag>
                <el-tag v-show="checkItem.includes('4')" type="danger"  >Paypal：C${{totalMoney.CAD.pay_pal_amount}} + US${{totalMoney.USD.pay_pal_amount}}</el-tag>
                <el-tag v-show="checkItem.includes('5')" type="danger"  >现金：C${{totalMoney.CAD.cash_amount}} + US${{totalMoney.USD.cash_amount}}</el-tag>
                <el-tag v-show="checkItem.includes('6')" type="danger"  >EMT：C${{totalMoney.CAD.emt_amount}} + US${{totalMoney.USD.emt_amount}}</el-tag>
                <el-tag v-show="checkItem.includes('7')" type="danger"  >小程序：C${{totalMoney.CAD.wechat_mini_amount}} + US${{totalMoney.USD.wechat_mini_amount}}</el-tag>
                <el-tag v-show="checkItem.includes('8')" type="danger"  >银联：C${{totalMoney.CAD.union_pay_amount}} + US${{totalMoney.USD.union_pay_amount}}</el-tag>
            </div>
            <el-input  v-model="title" @change="handleTitle"  placeholder="输入订单号查询" prefix-icon="el-icon-search" clearable style="width:240px;margin-right:20px">

            </el-input>
            <el-date-picker v-model="date" @change="handleDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:260px;margin-right:20px"></el-date-picker>
            <!-- <el-button type="success" plain @click="excel" style="width:150px;margin-left:30px;">Export</el-button> -->
            <el-select v-model="checkItem"  @change="handleType" clearable multiple collapse-tags placeholder="支付方式筛选" style="width:240px;margin-right:20px">
                <el-option label="支付宝" value="1"> </el-option>
                <el-option label="微信" value="2"> </el-option>
                <el-option label="VISA/Master" value="3"> </el-option>
                <el-option label="Paypal" value="4"> </el-option>
                <el-option label="现金" value="5"> </el-option>
                <el-option label="EMT" value="6"> </el-option>
                <el-option label="小程序" value="7"> </el-option>
                <el-option label="银联" value="8"> </el-option>
            </el-select>
            <el-select v-model="way"  @change="handleType" clearable placeholder="购买途径筛选" style="width:200px">
                <el-option label="线上商城" value="0"> </el-option>
                <el-option label="线下门店" value="1"> </el-option>
            </el-select>
            <el-button type="success" plain  style="width:120px;margin-left:20px;" @click="onSend()">导出报表</el-button>
            
        </div>
        
    
        <!-- 商品列表 -->
        <el-card >
            <el-table ref="table" :data="tableData"  height="500" >
                <el-table-column label="日期"  min-width="160" align="center">
                    <template slot-scope="scope">
                        <i class="el-icon-time"></i>
                        <span style="margin-left: 10px">{{ scope.row.transaction_time }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="order_title" label="订单号"  align="center" min-width="160"></el-table-column>
                   <el-table-column label="购买途径"  align="center" >
                    <template slot-scope="scope">
                       <el-link v-if="scope.row.way == 1">线下门店</el-link>
                       <el-link v-else>线上商城</el-link>
                    </template> 
                </el-table-column>
                <el-table-column prop="pay_method_title" label="支付方式" align="center"  > </el-table-column>
                <el-table-column prop="shops_title" label="所属商家" align="center"  ></el-table-column>
                <el-table-column label="交易类型"  align="center" >
                    <template slot-scope="scope">
                       <el-link type="success" v-if="scope.row.transaction_action == 1">支付</el-link>
                       <el-link type="warning" v-if="scope.row.transaction_action == 2">退款</el-link>
                    </template> 
                </el-table-column>
                <el-table-column prop="transaction_amount" label="交易金额"  align="center" >
                    <template slot-scope="scope">
                        <span>{{scope.row.trans_currency == 'USD'? 'US$':'C$'}}{{scope.row.transaction_amount}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="totalMoney" label="订单详情"  align="center"  >
                    <template slot-scope="scope">
                        <el-button @click="showDetail(scope.row)" type="danger" plain size="small">查看详情</el-button>
                    </template>
                </el-table-column>
                
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next" style="padding:15px" :total="total" ></el-pagination>
        </el-card>

          <!-- 展开商品详情弹框 -->
            <el-dialog title="订单详情" :visible.sync="detail_modal" :close-on-click-modal="false" center width="1200px" >

                <el-card class="m-bottom-4">
                    <el-row class="m-bottom-2">
                        <el-col :span="12" class="row-height">订单号码：{{detail.title}}</el-col>
                        <el-col :span="12" class="row-height">下单时间：{{detail.updated_at}}</el-col>
                    </el-row>
                    <el-row class="m-bottom-2">
                        <el-col :span="12" class="row-height">下单账号：{{detail.phone != "" ? detail.phone : (detail.email!=''?detail.email:(detail.order_logistics.tel!=''?detail.order_logistics.tel : detail.order_logistics.email))}}</el-col>
                        <el-col :span="12" class="row-height" v-if="detail.order_logistics.delivery_method == 0">收货方式：{{detail.delivery_method_title}} <span style="color:#409eff;">暂无</span></el-col>
                        <el-col :span="12" class="row-height" v-if="detail.order_logistics.delivery_method == 1">收货方式：{{detail.delivery_method_title}} <span style="color:#409eff;">MOOBYYOHO</span></el-col>
                        <el-col :span="12" class="row-height" v-if="detail.order_logistics.delivery_method == 2 || detail.order_logistics.delivery_method == 3">收货方式：{{detail.delivery_method_title}} <span style="color:#409eff;">{{detail.order_logistics.carrier_name}}</span></el-col>
                        <el-col :span="12" class="row-height" v-if="detail.order_logistics.delivery_method == 4">收货方式：{{detail.delivery_method_title}} <span style="color:#409eff;">商家自行配送</span></el-col>
                        <el-col :span="12" class="row-height" v-if="detail.order_logistics.delivery_method == 5">收货方式：{{detail.delivery_method_title}}</el-col>
                    </el-row>
                    <el-row class="row-height" v-if="detail.delivery_method == 1">取 件 码 ：{{detail.pick_up_code}}</el-row>
                    <el-row class="row-height" v-if="detail.delivery_method == 0"  style="padding-right:36px;">
                        地址详情：{{
                            detail.order_logistics.surname +
                            "  " +
                            detail.order_logistics.name +
                            "  "+
                            detail.order_logistics.tel +
                            ", " +
                            detail.order_logistics.address +
                            ", " +
                            (detail.order_logistics.city_arr ? detail.order_logistics.city_arr.ename : detail.order_logistics.city_name) +
                            ", " +
                            detail.order_logistics.province_arr.abbreviation +
                            ", " +
                            detail.order_logistics.country_arr.ename +
                            ", " +
                            detail.order_logistics.zipcode
                        }}
                    </el-row>
                </el-card>

                <el-card class="m-bottom-4" v-if="detail.title">
                    <p style="line-height:40px;color:#666;font-size:16px;border-bottom:1px solid #e0e0e0;text-align:center" >{{detail.shops_title}}</p>
                        <el-table :data="detail.order_goods" max-height="300">
                            <el-table-column label="商品图片"  align="center" width="100">
                                <template slot-scope="scope">
                                    <m-img v-if="scope.row.goods_sku_pic_url" :src="scope.row.goods_sku_pic_url" />
                                </template>
                            </el-table-column>
                            <el-table-column label="商品名称" show-overflow-tooltip  align="center" width="200">
                                <template slot-scope="scope">{{scope.row.goods_name}}</template>
                            </el-table-column>
                            <el-table-column label="商品规格"  align="center"  width="140" show-overflow-tooltip>
                                <template slot-scope="scope">{{scope.row.sku_name}}</template>
                            </el-table-column>
                            <el-table-column label="条形码"  align="center"  width="160">
                                <template slot-scope="scope">{{scope.row.barcode}}</template>
                            </el-table-column>
                            <el-table-column label="购买数量"   align="center" width="80">
                                <template slot-scope="scope">{{scope.row.goods_number}}</template> 
                            </el-table-column>
                            <el-table-column label="购买价格"  align="center">
                                <template slot-scope="scope">{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{scope.row.goods_price}}</template> 
                            </el-table-column>
                            <el-table-column label="PST"  align="center">
                                <template slot-scope="scope">{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ scope.row.pst_amount }}</template> 
                            </el-table-column>
                            <el-table-column label="GST"  align="center">
                                <template slot-scope="scope">{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ scope.row.gst_amount }}</template> 
                            </el-table-column>
                            <el-table-column label="HST"  align="center">
                                <template slot-scope="scope">{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ scope.row.hst_amount }}</template> 
                            </el-table-column>
                            <el-table-column label="QST"  align="center">
                                <template slot-scope="scope">{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ scope.row.qst_amount }}</template> 
                            </el-table-column>
                        </el-table>
                </el-card>
                <el-card  v-if="detail.title">
                    <el-row class="row-height" >
                        <span class="row-span">商品价格：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{detail.goods_amount}} </span>
                        <span class="row-span">钱包抵扣：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ detail.goods_wallet_fee }} </span>
                        <span class="row-span">优惠金额：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ detail.goods_discount_fee }} </span>
                        <span class="row-span" v-if="detail.pst_amount != '0.00'">PST：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{detail.pst_amount}} </span>
                        <span class="row-span" v-if="detail.gst_amount != '0.00'">GST：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{detail.gst_amount}} </span>
                        <span class="row-span" v-if="detail.hst_amount != '0.00'">HST：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{detail.hst_amount}} </span>
                        <span class="row-span" v-if="detail.qst_amount != '0.00'">QST：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{detail.qst_amount}} </span>
                        <span class="row-span">运费：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{detail.shipping_fee}}</span>
                    </el-row>
                    <p style="text-align:right;font-size:16px;font-weight:bold;padding:0 30px 10px 0;">支付总价：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{detail.order_total_amount}}</p>
                </el-card>
            </el-dialog>





    </section>
</template>



<script>
import { search } from '@/api/platform.js'
import { order_detail } from '@/api/order.js'
import MImg   from './../../../components/Image'
export default {
    components: { MImg },
    data() {
        return {
            date:[],
            title: '',
            checkItem:[],
            way: '',
            refundTotal:0,
            tableData:[],
            status:0,
            total:0,
            Total:'',
            page:1,
            totalMoney: {
                CAD: {
                    "alipay_amount": "0.00",  // 支付宝交易金额 
                    "wechat_amount": "0.00", // 微信交易金额 
                    "visa_mastercard_amount": "0.00", // visa交易金额 
                    "pay_pal_amount": "0.00", // paypal交易金额
                    "cash_amount": "0.00", // cash交易金额
                    "emt_amount": "0.00", // emt交易金额
                    "wechat_mini_amount": "0.00", // 微信小程序交易金额
                    "union_pay_amount": "0.00", // 银联交易金额
                    "total_pay_amount": "0.00", // 累计交易金额
                    "total_refund_amount": "0.00" // 累计退款金额
                },
                USD: {
                    "alipay_amount": "0.00",  // 支付宝交易金额 
                    "wechat_amount": "0.00", // 微信交易金额 
                    "visa_mastercard_amount": "0.00", // visa交易金额 
                    "pay_pal_amount": "0.00", // paypal交易金额
                    "cash_amount": "0.00", // cash交易金额
                    "emt_amount": "0.00", // emt交易金额
                    "wechat_mini_amount": "0.00", // 微信小程序交易金额
                    "union_pay_amount": "0.00", // 银联交易金额
                    "total_pay_amount": "0.00", // 累计交易金额
                    "total_refund_amount": "0.00" // 累计退款金额
                }
            },
            detail_modal:false,
            detail: {order_logistics:''}
        }
    },
    methods: {
        getData(){
            let params = {
                page:this.page
            }
            if(this.checkItem.length != 0){
                params.pay_search = this.checkItem.join(',')
            }
            if(this.way != '') {
                params.way_search = this.way
            }
            if(this.title != ""){
                params.title_search = this.title;
            }
            if(this.date && this.date.length != 0){
                params.start_date_search = this.date[0];
                params.end_date_search = this.date[1];
            }

            search(params).then(res => {
                if(res){
                    this.tableData = res.data.list.data
                    this.total = res.data.list.total
                    if (this.Total == '') {
                        this.Total = res.data.list.total
                    }
                    this.table_load = false;
                    if(res.data.statistics.CAD) {
                        this.totalMoney.CAD = res.data.statistics.CAD
                    }else{
                        this.totalMoney.CAD = {
                            "alipay_amount": "0.00",  // 支付宝交易金额 
                            "wechat_amount": "0.00", // 微信交易金额 
                            "visa_mastercard_amount": "0.00", // visa交易金额 
                            "pay_pal_amount": "0.00", // paypal交易金额
                            "cash_amount": "0.00", // cash交易金额
                            "emt_amount": "0.00", // emt交易金额
                            "wechat_mini_amount": "0.00", // 微信小程序交易金额
                            "union_pay_amount": "0.00", // 银联交易金额
                            "total_pay_amount": "0.00", // 累计交易金额
                            "total_refund_amount": "0.00" // 累计退款金额
                        }
                    }
                    if(res.data.statistics.USD) {
                        this.totalMoney.USD = res.data.statistics.USD
                    }else{
                        this.totalMoney.USD = {
                            "alipay_amount": "0.00",  // 支付宝交易金额 
                            "wechat_amount": "0.00", // 微信交易金额 
                            "visa_mastercard_amount": "0.00", // visa交易金额 
                            "pay_pal_amount": "0.00", // paypal交易金额
                            "cash_amount": "0.00", // cash交易金额
                            "emt_amount": "0.00", // emt交易金额
                            "wechat_mini_amount": "0.00", // 微信小程序交易金额
                            "union_pay_amount": "0.00", // 银联交易金额
                            "total_pay_amount": "0.00", // 累计交易金额
                            "total_refund_amount": "0.00" // 累计退款金额
                        }
                    }
                }else{
                    this.tableData = [] ;
                }
            })
        },
                 // 确认导出
        onSend(){
            if (!this.date || this.date.length == 0) {
                this.$message({ type:'error', message:'请先选择日期！' })
                return false
            }else{
                var a = document.createElement("a");
                a.href = `https://admintapi.moobyyoho.com/finance/transaction-export?start_date_search=${this.date[0]}&end_date_search=${this.date[1]}`;
                a.click();
            }
            
        },
        getRefundData() {
             let params = {
                page:this.page,
                action_search: 2,
            }
            search(params).then(res => {
                if (res) {
                    this.refundTotal = res.data.list.total;
                    // console.log(res.data.list.total);
                }
            });
        },
        // 订单号搜索
        handleTitle(){
            this.checkItem  = [];
            this.date = [];
            this.page = 1;
            this.getData();
        },
        // 日期查询搜索
        handleDate(){
            this.title      = '';
            this.checkItem  = [];
            this.page = 1;
            this.getData();
        },
        excel(){
            let params = '';
            console.log(this.date[0])
            if(this.date.length != 0){
                params =  `start_date=${this.date[0]}&end_date=${this.date[1]}`
            }
            let link = document.createElement('a');
            link.href = this.requestUrl + `finance/transactionexcel?${params}`
            document.body.appendChild(link);
            setTimeout( ()=>{
                link.click();
                // document.body.removeChild(link);
            },100)
        },
        // 支付方式搜索
        handleType(){
            this.title = '';
            // this.date = []
            this.page  = 1;
            this.getData();
        },
        handleSelect(rows){
            this.checkData = rows;
        },
        // 点击页数 加载当前点击页的数据
        reloadData(page){
            this.page = page;
            this.getData();
        },

         // 获取订单详情
        showDetail(row) {
            order_detail(row.order_id).then(res => {
                if(res) {
                    this.detail = res.data
                    this.detail_modal = true
                }
            })
        },

      
    },
    created(){
        this.getData();
        this.getRefundData();
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    /deep/ .el-tag + .el-tag{ 
        margin-left: 20px;
    }
    .right-total {
        position:absolute;right:0;
        /deep/ .el-tag {
            min-width:120px;
        }
    }
}
</style>
